/**
 * @generated SignedSource<<af57f00b93f5e658862715aca8e278ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateBlogArticleInput = {
  authorsIds: ReadonlyArray<string>;
  content: string;
  image?: any | null | undefined;
  imageAlt?: string | null | undefined;
  seoDescription?: string | null | undefined;
  seoTitle?: string | null | undefined;
  shortDescription: string;
  title: string;
};
export type BlogArticleCreatePageMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateBlogArticleInput;
};
export type BlogArticleCreatePageMutation$data = {
  readonly createBlogArticle: {
    readonly node: {
      readonly id: string;
      readonly slugLower: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"BlogArticleCardFragment" | "BlogArticleFragment">;
    };
  };
};
export type BlogArticleCreatePageMutation = {
  response: BlogArticleCreatePageMutation$data;
  variables: BlogArticleCreatePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugLower",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v10 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voterCount",
  "storageKey": null
},
v14 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v15 = {
  "alias": null,
  "args": [
    (v14/*: any*/)
  ],
  "concreteType": "VotersConnection",
  "kind": "LinkedField",
  "name": "voters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "voters(first:10)"
},
v16 = [
  (v14/*: any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": "HOT"
  }
],
v17 = {
  "alias": "viewerCanDelete",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
},
v18 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v20 = [
  (v3/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/)
      ],
      "type": "Entity",
      "abstractKey": "__isEntity"
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": "viewerCanReply",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votes",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "EntityVote",
  "kind": "LinkedField",
  "name": "voted",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "score",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": "viewerCanVote",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "PUBLISH_VOTE"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    (v13/*: any*/),
    (v15/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/)
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v32 = [
  "order"
],
v33 = {
  "alias": null,
  "args": (v16/*: any*/),
  "filters": (v32/*: any*/),
  "handle": "connection",
  "key": "CommentCommentsFragment_children",
  "kind": "LinkedHandle",
  "name": "children"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogArticleCreatePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BlogArticleEdge",
        "kind": "LinkedField",
        "name": "createBlogArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogArticle",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BlogArticleFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BlogArticleCardFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BlogArticleCreatePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BlogArticleEdge",
        "kind": "LinkedField",
        "name": "createBlogArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogArticle",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageAlt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blurHash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "seoTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "seoDescription",
                "storageKey": null
              },
              {
                "alias": "viewerCanEdit",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "UPDATE_BLOG_ARTICLE"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"UPDATE_BLOG_ARTICLE\")"
              },
              {
                "alias": "firstAuthor",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "BlogArticleAuthorConnection",
                "kind": "LinkedField",
                "name": "authors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "authors(first:1)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "CommentConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hotness",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v6/*: any*/),
                              (v19/*: any*/),
                              (v7/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": (v16/*: any*/),
                                "concreteType": "CommentConnection",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v6/*: any*/),
                                          (v19/*: any*/),
                                          (v7/*: any*/),
                                          (v21/*: any*/),
                                          (v22/*: any*/),
                                          (v23/*: any*/),
                                          (v24/*: any*/),
                                          {
                                            "alias": null,
                                            "args": (v16/*: any*/),
                                            "concreteType": "CommentConnection",
                                            "kind": "LinkedField",
                                            "name": "children",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CommentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v3/*: any*/),
                                                      (v17/*: any*/),
                                                      (v18/*: any*/),
                                                      (v6/*: any*/),
                                                      (v19/*: any*/),
                                                      (v7/*: any*/),
                                                      (v21/*: any*/),
                                                      (v22/*: any*/),
                                                      (v23/*: any*/),
                                                      (v24/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": (v16/*: any*/),
                                                        "concreteType": "CommentConnection",
                                                        "kind": "LinkedField",
                                                        "name": "children",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Comment",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v3/*: any*/),
                                                                  (v17/*: any*/),
                                                                  (v18/*: any*/),
                                                                  (v6/*: any*/),
                                                                  (v19/*: any*/),
                                                                  (v7/*: any*/),
                                                                  (v21/*: any*/),
                                                                  (v22/*: any*/),
                                                                  (v23/*: any*/),
                                                                  (v24/*: any*/),
                                                                  {
                                                                    "alias": null,
                                                                    "args": (v16/*: any*/),
                                                                    "concreteType": "CommentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "children",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "CommentEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v3/*: any*/),
                                                                              (v17/*: any*/),
                                                                              (v18/*: any*/),
                                                                              (v6/*: any*/),
                                                                              (v19/*: any*/),
                                                                              (v7/*: any*/),
                                                                              (v21/*: any*/),
                                                                              (v22/*: any*/),
                                                                              (v23/*: any*/),
                                                                              (v24/*: any*/),
                                                                              {
                                                                                "alias": null,
                                                                                "args": (v16/*: any*/),
                                                                                "concreteType": "CommentConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "children",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "concreteType": "Comment",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          (v3/*: any*/),
                                                                                          (v17/*: any*/),
                                                                                          (v18/*: any*/),
                                                                                          (v6/*: any*/),
                                                                                          (v19/*: any*/),
                                                                                          (v7/*: any*/),
                                                                                          (v21/*: any*/),
                                                                                          (v22/*: any*/),
                                                                                          (v23/*: any*/),
                                                                                          (v24/*: any*/),
                                                                                          {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "numChildren",
                                                                                            "storageKey": null
                                                                                          },
                                                                                          (v8/*: any*/),
                                                                                          (v28/*: any*/)
                                                                                        ],
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v29/*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                  },
                                                                                  (v30/*: any*/),
                                                                                  (v31/*: any*/)
                                                                                ],
                                                                                "storageKey": "children(first:10,order:\"HOT\")"
                                                                              },
                                                                              (v33/*: any*/),
                                                                              (v8/*: any*/),
                                                                              (v28/*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v29/*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      },
                                                                      (v30/*: any*/),
                                                                      (v31/*: any*/)
                                                                    ],
                                                                    "storageKey": "children(first:10,order:\"HOT\")"
                                                                  },
                                                                  (v33/*: any*/),
                                                                  (v8/*: any*/),
                                                                  (v28/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v29/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v30/*: any*/),
                                                          (v31/*: any*/)
                                                        ],
                                                        "storageKey": "children(first:10,order:\"HOT\")"
                                                      },
                                                      (v33/*: any*/),
                                                      (v8/*: any*/),
                                                      (v28/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v29/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v30/*: any*/),
                                              (v31/*: any*/)
                                            ],
                                            "storageKey": "children(first:10,order:\"HOT\")"
                                          },
                                          (v33/*: any*/),
                                          (v8/*: any*/),
                                          (v28/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v30/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": "children(first:10,order:\"HOT\")"
                              },
                              (v33/*: any*/),
                              (v8/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": "comments(first:10,order:\"HOT\")"
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "filters": (v32/*: any*/),
                    "handle": "connection",
                    "key": "TopicCommentsFragment_comments",
                    "kind": "LinkedHandle",
                    "name": "comments"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "type": "Votable",
                    "abstractKey": "__isVotable"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "topicHelmet",
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Forum",
                    "kind": "LinkedField",
                    "name": "forum",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forumOwnerKind",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "lastComments",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "last",
                        "value": 10
                      }
                    ],
                    "concreteType": "CommentConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "comments(last:10)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BlogArticleAuthorConnection",
                "kind": "LinkedField",
                "name": "authors",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "jobTitle",
                                "storageKey": null
                              }
                            ],
                            "type": "User",
                            "abstractKey": null
                          },
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "prependEdge",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createBlogArticle",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8c6e3a65e43856cdc070c374c731f0ef",
    "id": null,
    "metadata": {},
    "name": "BlogArticleCreatePageMutation",
    "operationKind": "mutation",
    "text": "mutation BlogArticleCreatePageMutation(\n  $input: CreateBlogArticleInput!\n) {\n  createBlogArticle(input: $input) {\n    node {\n      id\n      slugLower\n      title\n      ...BlogArticleFragment\n      ...BlogArticleCardFragment\n    }\n  }\n}\n\nfragment BlogArticleAuthorsFragment on BlogArticle {\n  authors {\n    edges {\n      node {\n        __typename\n        ... on User {\n          jobTitle\n        }\n        ...EntityAvatarFragment\n        id\n      }\n    }\n  }\n}\n\nfragment BlogArticleCardFragment on BlogArticle {\n  id\n  slugLower\n  title\n  shortDescription\n  image\n  blurHash\n  createdAt\n  firstAuthor: authors(first: 1) {\n    nodes {\n      __typename\n      ...EntityAvatarFragment\n      id\n    }\n  }\n  viewerCanEdit: viewerCan(action: UPDATE_BLOG_ARTICLE)\n}\n\nfragment BlogArticleFragment on BlogArticle {\n  id\n  slugLower\n  title\n  content\n  createdAt\n  shortDescription\n  image\n  imageAlt\n  blurHash\n  seoTitle\n  seoDescription\n  viewerCanEdit: viewerCan(action: UPDATE_BLOG_ARTICLE)\n  firstAuthor: authors(first: 1) {\n    nodes {\n      __typename\n      username\n      id\n    }\n  }\n  topic {\n    voterCount\n    voters(first: 10) {\n      ...EntitiesAvatarFragment\n    }\n    ...TopicCommentsFormTopicFragment\n    ...TopicCommentsFragment_tOpqv\n    ...VoteDisplayFragment\n    id\n  }\n  ...BlogArticleHelmetFragment\n  ...BlogArticleAuthorsFragment\n}\n\nfragment BlogArticleHelmetFragment on BlogArticle {\n  title\n  shortDescription\n  image\n  imageAlt\n  seoTitle\n  seoDescription\n  topicHelmet: topic {\n    ...TopicHelmetFragment\n    id\n  }\n  authors {\n    edges {\n      node {\n        __typename\n        id\n        kind\n        username\n      }\n    }\n  }\n}\n\nfragment CommentCommentsFragment_1C44UF on Comment {\n  children(first: 10, order: HOT) {\n    edges {\n      node {\n        id\n        ...CommentFragment_2wxvBB\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_1NLmsB on Comment {\n  children(first: 10, order: HOT) {\n    edges {\n      node {\n        id\n        ...CommentFragment_1vvAsf\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_1jcI8F on Comment {\n  children(first: 10, order: HOT) {\n    edges {\n      node {\n        id\n        ...CommentFragment_4swzNU\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_1vvAsf on Comment {\n  children(first: 10, order: HOT) {\n    edges {\n      node {\n        id\n        ...CommentFragment_1jcI8F\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentCommentsFragment_2wxvBB on Comment {\n  children(first: 10, order: HOT) {\n    edges {\n      node {\n        id\n        ...CommentFragment_1NLmsB\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentDeleteFragment on Comment {\n  id\n  author {\n    id\n  }\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n}\n\nfragment CommentDisplayFragment on Comment {\n  viewerCanDelete: viewerCan(action: DELETE_COMMENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_COMMENT)\n  id\n  content\n  edited\n  createdAt\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n  ...CommentDeleteFragment\n  author {\n    id\n    username\n    ...EntityProfilePicFragment_49kWkb\n  }\n  ...VoteDisplayFragment\n}\n\nfragment CommentFragment_1C44UF on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1C44UF\n}\n\nfragment CommentFragment_1NLmsB on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1NLmsB\n}\n\nfragment CommentFragment_1jcI8F on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1jcI8F\n}\n\nfragment CommentFragment_1vvAsf on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1vvAsf\n}\n\nfragment CommentFragment_2wxvBB on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_2wxvBB\n}\n\nfragment CommentFragment_4swzNU on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  numChildren\n}\n\nfragment CommentReplyFragment on Comment {\n  id\n  viewerCanReply: viewerCan(action: CREATE_COMMENT)\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityAvatarFragment on Entity {\n  __isEntity: __typename\n  username\n  ...EntityProfilePicFragment_49kWkb\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TopicCommentsFormTopicFragment on Topic {\n  id\n}\n\nfragment TopicCommentsFragment_tOpqv on Topic {\n  comments(first: 10, order: HOT) {\n    edges {\n      hotness\n      node {\n        id\n        ...CommentFragment_1C44UF\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TopicHelmetFragment on Topic {\n  id\n  title\n  description\n  createdAt\n  votes\n  author {\n    __typename\n    username\n    displayName\n    id\n  }\n  forum {\n    title\n    slug\n    owner {\n      __typename\n      slug\n      forumOwnerKind\n      id\n    }\n    id\n  }\n  lastComments: comments(last: 10) {\n    nodes {\n      content\n      createdAt\n      votes\n      author {\n        username\n        displayName\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "8390512b1f6c827a7f3443b95d481948";

export default node;
